import * as React from 'react';
import { useState } from 'react';
import cx from 'classnames';
const styles = require('./index.less');

const Indicator = ({ config, activeIndex, onChange }) => {
  const [isSpread, setIsSpread] = useState(false);

  const handleMouseEnter = () => {
    setIsSpread(true);
  };
  const handleMouseLeave = () => {
    setIsSpread(false);
  };
  const handleMenuClick = index => {
    onChange?.(index);
  };

  return (
    <div className={cx(styles.root, isSpread && styles.isSpread)}>
      <h2 className={styles.title}>archive</h2>
      <div className={styles.indicator}>
        {config?.map((_, index) => {
          return <div key={index} className={cx(styles.indicatorItem, index === activeIndex && styles.indicatorActive)} />;
        })}
      </div>
      <div className={styles.menu}>
        <div className={styles.fold}>
          <div className={styles.btnMore} onMouseEnter={handleMouseEnter} />
        </div>
        <div className={styles.spread} onMouseLeave={handleMouseLeave}>
          {/* <div className={styles.spreadTitle} /> */}
          <ol>
            {config?.map((item, index) => {
              return (
                <li key={index} className={cx(index === activeIndex && styles.active)} onClick={() => handleMenuClick(index)}>
                  <span>{String(index + 1).padStart(2, '0')}.</span>
                  {item}
                </li>
              );
            })}
          </ol>
        </div>
      </div>
    </div>
  );
};

export default Indicator;
